<template>
  <svg
    class="loading-logo"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 260.1 217.9"
  >
    <path
      class="st0"
      d="M113.5,147.6c1.3-3,2.5-1.7,3.4-4.4c-0.3-1.4-1.9-3.9-2.8-4.3c-2.9-1.2-2,0.7-4.9-2.1c-1.3-1.3-3-1.8-4.9-0.9
      c-2.6,1.3-0.5,2.4-4,3.5c-2.6,0.7-2.8,0.4-5.1,2c-2.3,1.6-1.8,2.1-2.7,4.8c-0.9,2.8-2.9,4.5-5.8,8.7c-2.2,3.3-2.3,6.6-4.6,9.5
      c-7.3,9.4-4.2,12.3-5.1,15.6c-1.8,6.9-1.1,5.6,0.2,8.6l1.9,5.2c1.4,5.5-0.5,2.3,4.6,6.4c2.1,1.6,2.6,0.6,3.6,3.4
      c0.9,2.5-0.7,6.7,2.7,7.8c0.2,0.1,3.4,0.7,3.5,0.7c3.6-0.1,0.6-5.9,2.6-11.9c3.4-10.3,3-3.3,5.1-9.4c1.6-4.7,3.4-2,5-9.1
      c0.5-2.2,1.1-3.3,1.3-5.8c0.2-2.6,0.5-3.9,1-6.5c0.5-2.2,0.8-3.6,1.2-5.8l4.2-10.3C115.4,149.2,114.3,150.2,113.5,147.6L113.5,147.6
      z"
    />
    <path
      class="st1"
      d="M9.1,146.1c2.6-0.2,5.4-0.4,8.3-0.5c2.9-0.1,5.9-0.2,8.9-0.3c3-0.1,6-0.1,9,0c3,0.1,6,0.2,8.9,0.3
      c-0.7,2.4-1.4,4.7-2,7c-0.6,2.3-1.2,4.5-1.7,6.7c-1.5-0.1-3.2-0.1-4.9-0.2c-1.7,0-3.5,0-5.3,0.1c-0.8,2.7-1.6,5.5-2.5,8.4
      c-0.9,2.9-1.7,5.8-2.6,8.7c-0.9,2.9-1.7,5.8-2.5,8.7c-0.8,2.9-1.6,5.7-2.3,8.3c-2-0.2-4.1-0.2-6.3-0.2c-2.2,0.1-4.3,0.2-6.3,0.3
      c0.7-2.6,1.3-5.3,2-8.1c0.7-2.8,1.4-5.7,2.1-8.6c0.7-2.9,1.4-5.9,2.1-8.8c0.7-2.9,1.4-5.8,2.2-8.6c-1.7-0.1-3.4-0.1-5.2,0
      c-1.8,0.1-3.5,0.1-5.2,0.2c0.3-2.2,0.8-4.4,1.4-6.7C7.5,150.6,8.3,148.4,9.1,146.1L9.1,146.1z"
    />
    <g>
      <g>
        <path
          class="st1"
          d="M71.4,169.6c-0.1-8.1-0.1-16.2-0.2-24.3c-2.9-0.1-5.8-0.1-8.6,0c-2.8,0.1-5.8,0.3-9,0.8
          c-3.9,7.7-7.8,15.5-11.4,23.5c-3.7,8-7.3,15.8-10.7,23.5c3.8-0.4,7.7-0.4,11.9,0c0.7-1.3,1.4-2.5,2.1-3.7c0.6-1.2,1.2-2.5,1.8-3.6
          c2.2-0.2,4.3-0.3,6.2-0.3c1.9,0,3.7-0.1,5.6-0.2c0,1.4-0.1,2.8-0.1,4.2c0,1.4-0.1,2.8-0.2,4.2c2-0.2,4-0.3,6.2-0.3
          c2.1,0,4.2,0.1,6.2,0.1C71.3,185.7,71.4,177.7,71.4,169.6z M60.8,174.1c-1.8-0.2-3.5-0.3-5.1-0.3c-1.6,0-3.2,0.1-4.9,0.1
          c1.5-2.8,3-5.6,4.6-8.5c1.5-2.9,3.1-5.8,4.8-8.5c0.2,2.8,0.3,5.7,0.5,8.6C60.8,168.5,60.9,171.3,60.8,174.1z"
        />
      </g>
    </g>
    <path
      class="st1"
      d="M118.5,146.8c2.2-0.2,4.4-0.4,6.6-0.5c2.2-0.1,4.6-0.1,7,0c-0.4,1.8-0.7,3.7-0.9,5.7c-0.3,2-0.5,4-0.7,6.1
      c-0.2,2-0.4,4-0.6,6c-0.2,2-0.3,3.9-0.5,5.7c2-3.7,4.1-7.5,6.1-11.4c2-3.9,4-7.7,5.9-11.3c1.3-0.1,2.6-0.2,4.1-0.3
      c1.5-0.1,3-0.1,4.5,0c-0.1,1.8-0.3,3.6-0.4,5.5c-0.1,1.9-0.2,3.8-0.3,5.8c-0.1,1.9-0.1,3.8-0.1,5.7c0,1.8,0,3.5,0,5.1
      c2-3.8,3.9-7.7,5.7-11.6c1.8-3.9,3.5-7.7,5.1-11.4c2.5-0.1,5-0.1,7.7-0.2c2.7,0,5.3,0.1,7.9,0.2c-2.2,3.9-4.5,7.9-6.6,11.8
      c-2.2,3.9-4.4,7.8-6.6,11.8c-2.2,3.9-4.5,7.9-6.8,11.9c-2.3,4-4.8,8-7.3,12c-2-0.1-3.8-0.1-5.3-0.1c-1.6,0.1-3.1,0.1-4.7,0.3
      c0-2.6,0-5.6,0.1-9.1c0.1-3.5,0.2-7.2,0.4-11.1c-0.8,1.5-1.8,3.2-2.8,4.9c-1,1.7-2,3.5-3.1,5.2c-1.1,1.8-2.1,3.5-3.1,5.3
      c-1,1.8-2,3.4-2.9,4.9c-0.9,0-1.7-0.1-2.4-0.1c-0.8,0-1.5,0-2.2,0c-0.7,0-1.5,0-2.2,0.1c-0.7,0.1-1.6,0.1-2.5,0.2
      c-0.1-7.4-0.1-15.1,0.1-23.1C117.6,162.9,118,154.9,118.5,146.8L118.5,146.8z"
    />
    <g>
      <g>
        <path
          class="st1"
          d="M200.6,169.6c-0.1-8.1-0.1-16.2-0.2-24.3c-2.9-0.1-5.8-0.1-8.6,0c-2.8,0.1-5.8,0.3-9,0.8
          c-3.9,7.7-7.8,15.5-11.4,23.5c-3.7,8-7.3,15.8-10.7,23.5c3.8-0.4,7.7-0.4,11.9,0c0.7-1.3,1.4-2.5,2.1-3.7c0.6-1.2,1.2-2.5,1.8-3.6
          c2.2-0.2,4.3-0.3,6.2-0.3c1.9,0,3.7-0.1,5.6-0.2c0,1.4-0.1,2.8-0.1,4.2c0,1.4-0.1,2.8-0.2,4.2c2-0.2,4-0.3,6.2-0.3
          c2.2,0,4.2,0.1,6.2,0.1C200.5,185.7,200.7,177.7,200.6,169.6z M190.1,174.1c-1.8-0.2-3.5-0.3-5.1-0.3c-1.6,0-3.2,0.1-4.9,0.1
          c1.5-2.8,3-5.6,4.6-8.5c1.5-2.9,3.1-5.8,4.8-8.5c0.2,2.8,0.3,5.7,0.5,8.6C190.1,168.5,190.1,171.3,190.1,174.1z"
        />
      </g>
    </g>
    <path
      class="st1"
      d="M215.8,147.1c2.9-0.3,5.4-0.6,7.8-0.6c2.3,0,4.7,0,7.1,0c0.1,1.9,0.2,3.9,0.3,6.1c0.1,2.2,0.3,4.5,0.5,6.8
      c0.2,2.3,0.4,4.6,0.6,6.8c0.2,2.2,0.3,4.2,0.5,6c0.9-4.3,2-8.7,3.3-13.1c1.2-4.4,2.5-8.8,3.9-13.2c1-0.1,2-0.3,3.2-0.4
      c1.2-0.1,2.4-0.2,3.7-0.2c1.3,0,2.5-0.1,3.8,0c1.3,0,2.4,0.1,3.5,0.2c-2.8,7.9-5.4,15.9-7.9,23.9c-2.4,8-4.6,15.9-6.6,23.7
      c-2.3-0.1-4.8-0.1-7.5,0.1c-2.7,0.1-5.1,0.3-7.4,0.7c-0.1-1.5-0.3-3.2-0.5-5.1c-0.2-1.9-0.4-3.9-0.6-5.9c-0.2-2.1-0.5-4.1-0.7-6.2
      c-0.2-2.1-0.4-4.1-0.6-6c-1.3,4-2.4,7.9-3.4,11.6c-1,3.7-1.9,7.5-2.9,11.3c-2.2,0-4.2-0.1-6.1,0c-1.8,0-3.8,0.1-6,0.2
      c0.8-3.7,1.7-7.4,2.5-11.4c0.9-3.9,1.9-7.9,2.9-11.8c1-4,2-7.9,3.1-11.9C213.5,154.7,214.6,150.8,215.8,147.1L215.8,147.1z"
    />
    <g>
      <path
        class="st1"
        d="M119.2,201h-2.2v-1.4h6.2v1.4h-2.2v7.2h-1.7V201z"
      />
      <path
        class="st1"
        d="M127.6,199.4c0.4,0,0.8,0.1,1.1,0.2s0.6,0.3,0.9,0.5c0.2,0.2,0.4,0.5,0.5,0.8s0.2,0.6,0.2,1v4.1
        c0,0.3-0.1,0.7-0.2,1c-0.1,0.3-0.3,0.6-0.5,0.8c-0.2,0.2-0.5,0.4-0.9,0.5c-0.3,0.1-0.7,0.2-1.1,0.2h-1.1c-0.4,0-0.8-0.1-1.1-0.2
        c-0.3-0.1-0.6-0.3-0.9-0.5c-0.2-0.2-0.4-0.5-0.5-0.8c-0.1-0.3-0.2-0.6-0.2-1v-4.1c0-0.3,0.1-0.7,0.2-1c0.1-0.3,0.3-0.6,0.5-0.8
        c0.2-0.2,0.5-0.4,0.9-0.5c0.3-0.1,0.7-0.2,1.1-0.2H127.6z M126.6,200.9c-0.3,0-0.5,0.1-0.7,0.3s-0.3,0.5-0.3,0.9v3.7
        c0,0.4,0.1,0.7,0.3,0.9s0.4,0.3,0.7,0.3h1c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.5,0.3-0.9V202c0-0.4-0.1-0.7-0.3-0.9
        c-0.2-0.2-0.4-0.3-0.7-0.3H126.6z"
      />
      <path
        class="st1"
        d="M138.6,205.8c0,0.4-0.1,0.7-0.2,1c-0.1,0.3-0.3,0.6-0.6,0.8c-0.3,0.2-0.6,0.4-1,0.5c-0.4,0.1-0.9,0.2-1.5,0.2
        c-0.6,0-1.1-0.1-1.5-0.2c-0.4-0.1-0.8-0.3-1-0.5c-0.3-0.2-0.5-0.5-0.6-0.8c-0.1-0.3-0.2-0.7-0.2-1v-6.2h1.7v5.8
        c0,0.2,0,0.5,0.1,0.6c0.1,0.2,0.1,0.4,0.3,0.5c0.1,0.1,0.3,0.2,0.5,0.3c0.2,0.1,0.4,0.1,0.7,0.1c0.3,0,0.5,0,0.7-0.1
        c0.2-0.1,0.4-0.2,0.5-0.3s0.2-0.3,0.2-0.5c0-0.2,0.1-0.4,0.1-0.6v-5.8h1.7V205.8z"
      />
      <path
        class="st1"
        d="M144.7,208.2l-1.7-3.4h-0.8v3.4h-1.7v-8.6h3.1c0.9,0,1.6,0.2,2.1,0.7c0.5,0.4,0.7,1,0.7,1.8c0,0.4,0,0.7-0.1,1
        c-0.1,0.3-0.2,0.5-0.3,0.8c-0.1,0.2-0.3,0.4-0.5,0.5s-0.4,0.2-0.7,0.3l1.9,3.6H144.7z M143.5,203.4c0.4,0,0.6-0.1,0.8-0.3
        c0.2-0.2,0.3-0.5,0.3-1c0-0.4-0.1-0.7-0.3-0.8c-0.2-0.2-0.5-0.3-0.8-0.3h-1.3v2.5H143.5z"
      />
      <path
        class="st1"
        d="M147.8,208.2v-8.6h1.7v8.6H147.8z"
      />
      <path
        class="st1"
        d="M151.1,201.6c0-0.3,0.1-0.6,0.2-0.9c0.1-0.3,0.3-0.5,0.5-0.7c0.2-0.2,0.5-0.3,0.8-0.5c0.3-0.1,0.7-0.2,1.1-0.2
        h0.3c0.7,0,1.3,0.2,1.8,0.5c0.4,0.4,0.8,0.9,0.9,1.7l-1.7,0.2c0-0.2-0.1-0.4-0.1-0.6c-0.1-0.1-0.2-0.3-0.3-0.3s-0.2-0.1-0.3-0.2
        s-0.2,0-0.4,0h-0.2c-0.1,0-0.3,0-0.4,0.1c-0.1,0-0.2,0.1-0.3,0.2c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.1-0.1,0.2-0.1,0.4v0.1
        c0,0.1,0,0.3,0.1,0.4c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.2,0.1,0.3,0.2s0.2,0.1,0.3,0.1l1.4,0.5c0.3,0.1,0.5,0.2,0.8,0.4
        s0.4,0.3,0.6,0.5c0.2,0.2,0.3,0.4,0.4,0.6s0.1,0.5,0.1,0.8v0.6c0,0.3-0.1,0.6-0.2,0.9c-0.1,0.3-0.3,0.5-0.5,0.7
        c-0.2,0.2-0.5,0.4-0.9,0.5s-0.7,0.2-1.1,0.2h-0.4c-0.3,0-0.6,0-0.8,0c-0.3,0-0.5-0.1-0.8-0.2c-0.2-0.1-0.5-0.2-0.7-0.3
        s-0.4-0.2-0.6-0.4v-1.7c0.2,0.2,0.4,0.4,0.6,0.5c0.2,0.2,0.4,0.3,0.7,0.4c0.2,0.1,0.5,0.2,0.8,0.2c0.3,0.1,0.5,0.1,0.8,0.1h0.2
        c0.4,0,0.6-0.1,0.8-0.2s0.3-0.4,0.3-0.7v-0.2c0-0.3-0.1-0.5-0.2-0.7c-0.1-0.2-0.4-0.3-0.7-0.4l-1.1-0.3c-0.3-0.1-0.6-0.2-0.9-0.4
        c-0.3-0.1-0.5-0.3-0.7-0.5s-0.3-0.4-0.4-0.7c-0.1-0.3-0.2-0.6-0.2-0.9V201.6z"
      />
      <path
        class="st1"
        d="M166.4,202.8c0-0.2,0-0.3,0-0.4c0-0.1,0-0.3,0-0.4s0-0.2,0-0.3s0-0.2,0-0.3c0,0.2-0.1,0.3-0.1,0.5
        s-0.1,0.4-0.2,0.5c-0.1,0.2-0.1,0.4-0.2,0.5c-0.1,0.2-0.1,0.3-0.1,0.4l-2,4.9h-1.5l-1.9-4.9c0-0.1-0.1-0.3-0.2-0.4
        c-0.1-0.2-0.1-0.3-0.2-0.5c-0.1-0.2-0.1-0.4-0.1-0.5s-0.1-0.4-0.1-0.5c0,0.2,0,0.4,0,0.7c0,0.3,0,0.5,0,0.8v5.4h-1.6v-8.6h2.2
        l2.4,6c0,0.1,0.1,0.2,0.1,0.4c0,0.1,0.1,0.3,0.1,0.4c0-0.2,0.1-0.3,0.1-0.4c0-0.1,0.1-0.3,0.1-0.4l2.4-6h2.2v8.6h-1.6V202.8z"
      />
      <path
        class="st1"
        d="M177.1,206h-2.9l-0.6,2.2h-1.8l2.7-8.6h2.2l2.7,8.6h-1.8L177.1,206z M176.8,204.6l-0.6-1.9
        c-0.1-0.2-0.1-0.4-0.2-0.6c-0.1-0.2-0.1-0.4-0.2-0.6c-0.1-0.2-0.1-0.4-0.2-0.6c0,0.2-0.1,0.4-0.2,0.6c-0.1,0.2-0.1,0.4-0.2,0.6c-0.1,0.2-0.1,0.4-0.2,0.6l-0.5,1.9H176.8z"
      />
      <path
        class="st1"
        d="M181,201h-2.2v-1.4h6.2v1.4h-2.2v7.2H181V201z"
      />
      <path
        class="st1"
        d="M187.5,201h-2.2v-1.4h6.2v1.4h-2.2v7.2h-1.7V201z"
      />
      <path
        class="st1"
        d="M196.6,208.2l-1.7-3.4h-0.8v3.4h-1.7v-8.6h3.1c0.9,0,1.6,0.2,2.1,0.7c0.5,0.4,0.7,1,0.7,1.8c0,0.4,0,0.7-0.1,1
        c-0.1,0.3-0.2,0.5-0.3,0.8c-0.1,0.2-0.3,0.4-0.5,0.5s-0.4,0.2-0.7,0.3l1.9,3.6H196.6z M195.5,203.4c0.4,0,0.6-0.1,0.8-0.3
        c0.2-0.2,0.3-0.5,0.3-1c0-0.4-0.1-0.7-0.3-0.8c-0.2-0.2-0.5-0.3-0.8-0.3h-1.3v2.5H195.5z"
      />
      <path
        class="st1"
        d="M204,206h-2.9l-0.6,2.2h-1.8l2.7-8.6h2.2l2.7,8.6h-1.8L204,206z M203.6,204.6l-0.6-1.9
        c-0.1-0.2-0.1-0.4-0.2-0.6c-0.1-0.2-0.1-0.4-0.2-0.6c-0.1-0.2-0.1-0.4-0.2-0.6c0,0.2-0.1,0.4-0.2,0.6c-0.1,0.2-0.1,0.4-0.2,0.6
        c-0.1,0.2-0.1,0.4-0.2,0.6l-0.5,1.9H203.6z"
      />
      <path
        class="st1"
        d="M210.7,207c0.2,0,0.5,0,0.7-0.1s0.5-0.2,0.7-0.3c0.2-0.1,0.4-0.3,0.6-0.4c0.2-0.1,0.3-0.2,0.4-0.3v1.6
        c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.3,0.2-0.6,0.3c-0.2,0.1-0.5,0.2-0.8,0.2c-0.3,0.1-0.6,0.1-1,0.1h-0.5c-0.4,0-0.8-0.1-1.2-0.2
    c-0.3-0.1-0.6-0.3-0.9-0.5c-0.2-0.2-0.4-0.5-0.5-0.8c-0.1-0.3-0.2-0.6-0.2-1v-4.1c0-0.3,0.1-0.7,0.2-1c0.1-0.3,0.3-0.6,0.5-0.8
    c0.2-0.2,0.5-0.4,0.9-0.5c0.3-0.1,0.7-0.2,1.1-0.2h0.5c0.4,0,0.7,0.1,1,0.2c0.3,0.1,0.6,0.3,0.8,0.5c0.2,0.2,0.4,0.4,0.5,0.7
    s0.2,0.6,0.3,0.9l-1.7,0.2c0-0.2-0.1-0.3-0.1-0.5c-0.1-0.1-0.1-0.2-0.2-0.3s-0.2-0.2-0.3-0.2c-0.1,0-0.2-0.1-0.4-0.1H210
    c-0.3,0-0.6,0.1-0.8,0.3c-0.2,0.2-0.3,0.5-0.3,1v3.2c0,1.1,0.5,1.6,1.4,1.6H210.7z"
      />
      <path
        class="st1"
        d="M215.9,201h-2.2v-1.4h6.2v1.4h-2.2v7.2h-1.7V201z"
      />
      <path
        class="st1"
        d="M220.8,208.2v-8.6h1.7v8.6H220.8z"
      />
      <path
        class="st1"
        d="M228.1,199.4c0.4,0,0.8,0.1,1.1,0.2c0.3,0.1,0.6,0.3,0.9,0.5s0.4,0.5,0.5,0.8s0.2,0.6,0.2,1v4.1
        c0,0.3-0.1,0.7-0.2,1c-0.1,0.3-0.3,0.6-0.5,0.8c-0.2,0.2-0.5,0.4-0.9,0.5c-0.3,0.1-0.7,0.2-1.1,0.2H227c-0.4,0-0.8-0.1-1.1-0.2
        c-0.3-0.1-0.6-0.3-0.9-0.5c-0.2-0.2-0.4-0.5-0.5-0.8c-0.1-0.3-0.2-0.6-0.2-1v-4.1c0-0.3,0.1-0.7,0.2-1c0.1-0.3,0.3-0.6,0.5-0.8
        c0.2-0.2,0.5-0.4,0.9-0.5c0.3-0.1,0.7-0.2,1.1-0.2H228.1z M227.1,200.9c-0.3,0-0.5,0.1-0.7,0.3s-0.3,0.5-0.3,0.9v3.7
        c0,0.4,0.1,0.7,0.3,0.9s0.4,0.3,0.7,0.3h1c0.3,0,0.5-0.1,0.7-0.3s0.3-0.5,0.3-0.9V202c0-0.4-0.1-0.7-0.3-0.9s-0.4-0.3-0.7-0.3
        H227.1z"
      />
      <path
        class="st1"
        d="M238.2,199.6h1.7v8.6H238l-3.8-6.2c0,0.3,0,0.5,0,0.8c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3
        c0,0.1,0,0.2,0,0.3v4.2h-1.7v-8.6h1.9l3.8,6.2c0-0.2,0-0.4,0-0.6c0-0.2,0-0.4,0-0.6c0-0.2,0-0.4,0-0.6V199.6z"
      />
    </g>
    <path
      class="st0"
      d="M152.2,25.5c0-0.1,0.1-1.2,0.1-1.1c9.2-1.3,12.6-4.5,12.1-7.4c-0.5-3.4-6.5-6.2-15.1-4.4
      c-3.7-4.9-10.1-6.6-15.8-5.5c-9.5,1.8-11.9,8.8-11.6,16.6c0.2,5.4,1.7,11.2,3,15.9c-7.7-0.2-17.1,0.1-22.8,5.9
      c-4.7,4.8-6.8,12.6-7.4,20.9c-0.7,9,0.5,18.7,1.8,25.6c-3.3-5.8-5.3-12.3-6-18.9c-5,7.3-11.4,17.5-14.7,25.7
      c-2.1,5.3-3,9.6-1.4,11.9c2.3,4.1,3.8,6.4,5.1,7.6c-16.1,3.5-31.8,8.7-47.1,15.6c32.3-9.4,65.8-14,99.2-13.7
      c31.5,0.3,63,4.8,93.3,13.7c-21.5-9.7-44.1-16.1-67-19c-0.5-10.9,0.3-20.9,3.9-26.4c6.2-9.7,26.8-14.2,36.5-21.4
      c4.9-3.6,7-7.9,3.2-13.8c-7.6-8.1-16.9-17.6-28-23.1C167.3,26.8,160.1,24.9,152.2,25.5L152.2,25.5z M134.4,72.2
      c-0.1-3.8-0.7-9.1-2.4-10.7c-0.9-0.8-2.3-1.1-4.5-1.4c-8.1-1.3-21.8-0.3-22.6,0.3c2-2.9,14.7-4.4,23.3-3.4c3,0.4,4.8,0.9,6,2
      C136.8,61.4,135.9,70.1,134.4,72.2L134.4,72.2z M151.4,35.7c3.5-0.8,3.6-2.6,0.2-5.5v0c0,0,1.3,0.2,3.8,0.6c3,3.2,7.2,4.3,12.8,3.5
      c0,0,4.9,6.3,14.7,18.8c-1.9-0.1-4,0.2-6.3,0.8c-1.7,0.5-3.6,1.1-5.5,2c-2.4-1.2-5.1-1.8-8-1.9c-2.8,0-5.8,0.5-9,1.6
      c0.2,9.9-1.9,19.8-6,28.8c1.4-9.2,2.8-27.2-2-35.5C150,46,151,43.1,151.4,35.7L151.4,35.7z M102,114.4c-1.7,0.2-3.3,0.4-5,0.6
      c-1.6-2.7-3.4-5.1-5.5-6.9c1.4-0.8,4.1-3.2,7.1-6.6C99.8,106.3,100.9,110.7,102,114.4z"
    />
    <path
      class="st2"
      d="M66.7,61.1c-8.9-1.2-17.2,4.4-19.5,13c-3.1,11.6,6.1,23,18.2,22.2c-8.9-1.9-13.5-11.5-9.8-19.6
      c2.5-5.4,8.3-8.8,14.5-7.9c0.8-7.2,5.4-12.8,11.3-15.6c4.1-1.9,9-2.4,13.7-1.1c0.9-2.2,2-4.3,3.4-6c-6.7-2.8-13.8-2.3-19.8,0.7
      C73.1,49.5,68.6,54.5,66.7,61.1L66.7,61.1z M173.8,83.4c6.1-1.1,12.3,0.6,17,4.6c3.9,3.3,6.6,8.1,7.2,13.5c5.8-1.9,12-0.4,16.7,3.6
      c6.6,5.6,7.9,14.4,3.4,21.8c7-7.4,7.1-18.9,0.5-26.5c-4-4.6-10.1-7.2-16.4-6.7c-1.1-3.9-3.2-7.4-5.9-10.3c-2.7-2.8-6.1-5-9.9-6.3
      C182,79,177.5,81,173.8,83.4z"
    />
  </svg>
</template>
<script>
export default {
  name: 'LoadingLogo',
  data () {
    return {
    }
  }
}
</script>
<style lang="scss" scoped>
  .loading-logo{
    fill: $secondaryColor;
    width: 140px;
  }
</style>
